import axios, { type AxiosInstance } from "axios";
import { env } from "@/env";
import { requestAdminStepUp } from "@/lib/admin-access";
import {
  getNativeIdentity,
  impersonationReadOnlyMessage,
} from "@/lib/native-auth";

// Cookie-authenticated client for the v2 backend (Bun/Hono).
const axiosClientV2: AxiosInstance = axios.create({
  baseURL: env.VITE_API_V2_BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

axiosClientV2.interceptors.request.use(async (config) => {
  const expectedUid = config.expectedUserUid;
  delete config.expectedUserUid;
  if (expectedUid && getNativeIdentity()?.uid !== expectedUid)
    throw Error("Account changed before request");
  config.withCredentials = true;
  config.headers.delete("Authorization");
  return config;
});

axiosClientV2.interceptors.response.use(undefined, (error: unknown) => {
  if (
    axios.isAxiosError(error) &&
    error.response?.data?.error?.code === "ADMIN_STEP_UP_REQUIRED"
  )
    requestAdminStepUp();
  if (
    axios.isAxiosError(error) &&
    error.response?.data?.error?.code === "IMPERSONATION_READ_ONLY"
  ) {
    error.message = impersonationReadOnlyMessage;
    error.response.data.error.message = impersonationReadOnlyMessage;
  }
  return Promise.reject(error);
});

export default axiosClientV2;
